// extracted by mini-css-extract-plugin
export var footerStyles = "Footer-module--footerStyles--0d8a9";